import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e8306f38"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2MobilePagesGamePage: require('/app/components/Theme2/Mobile/Pages/GamePage.vue').default,Theme2HomePage: require('/app/components/Theme2/HomePage.vue').default,CommonsPopup: require('/app/components/Commons/Popup.vue').default})
